import React from 'react';
import './shared-chrome.css';

/**
 * StatLine — inline stats ("27 accounts · 23 matched · 18 BU codes").
 * Replaces rows of boxed KPI cards when the numbers describe the view
 * rather than being its content (audit §5 "Caps everywhere").
 * stats: array of { value, label } (falsy entries are skipped).
 */
export default function StatLine({ stats = [] }) {
  const shown = stats.filter(Boolean);
  if (!shown.length) return null;
  return (
    <div className="ts-stat-line">
      {shown.map((s, i) => (
        <span key={i} className="ts-stat">
          <strong>{s.value}</strong> {s.label}
        </span>
      ))}
    </div>
  );
}
